// Contactformulier → verstuurt via hetzelfde GraphQL-endpoint als de chat-widget
// (submitChatQuestion). Vervangt de oude, onbetrouwbare mailto-submit.
import { resolveGraphQLEndpoint } from './graphql-endpoint.js';

document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('contact-form');
  if (!form) return;

  const status = document.getElementById('contact-status');
  const submitBtn = form.querySelector('[type="submit"]');
  const endpoint = resolveGraphQLEndpoint();

  function setStatus(message, kind) {
    if (!status) return;
    status.textContent = message || '';
    const colour = kind === 'error' ? 'text-red-600' : kind === 'success' ? 'text-green-600' : 'text-gray-500';
    status.className = `mt-3 text-sm ${colour}`;
    status.classList.toggle('hidden', !message);
  }

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const naam = (form.querySelector('#naam')?.value || '').trim();
    const email = (form.querySelector('#email')?.value || '').trim();
    const bericht = (form.querySelector('#bericht')?.value || '').trim();

    if (!naam || !email || !bericht) {
      setStatus('Vul je naam, e-mailadres en bericht in.', 'error');
      return;
    }
    if (!isValidEmail(email)) {
      setStatus('Vul een geldig e-mailadres in.', 'error');
      return;
    }
    if (bericht.length < 8) {
      setStatus('Je bericht is te kort. Geef wat meer details (minstens 8 tekens).', 'error');
      return;
    }

    const parts = naam.split(/\s+/);
    const firstName = parts.shift() || naam;
    const lastName = parts.join(' ');

    if (submitBtn) submitBtn.disabled = true;
    setStatus('Versturen…', 'info');

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          query: `mutation SubmitChatQuestion($input: ChatQuestionInput!) {
            submitChatQuestion(input: $input) { id status }
          }`,
          variables: {
            input: {
              firstName,
              lastName,
              email,
              question: bericht,
              pageUrl: window.location.href,
              predictionUrl: '',
              referrer: (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('referrer')) || document.referrer || '',
              sessionId: (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('session_id')) || '',
              source: 'contact-form',
              userAgent: navigator.userAgent,
            },
          },
        }),
      });

      const data = await response.json().catch(() => ({}));
      if (!response.ok || data.errors?.length || !data.data?.submitChatQuestion) {
        throw new Error(data.errors?.[0]?.message || 'submit failed');
      }

      form.reset();
      setStatus('Bedankt! We hebben je bericht ontvangen en nemen contact op via e-mail.', 'success');
    } catch (error) {
      const friendly = error && error.message && error.message !== 'submit failed'
        ? error.message
        : 'Versturen lukte niet. Probeer het straks opnieuw of mail rechtstreeks naar info@woningschatting.be.';
      setStatus(friendly, 'error');
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  });
});
